import React from 'react'

export const VideoHomeButton = () => {
  return (
    <div className="video-container">
      <iframe 
        src="https://www.youtube.com/embed/WDUFARc7TFs" 
        frameBorder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      />
    </div>
  )
}
